module.exports = __webpack_public_path__ + "img/paper.b384ea94.png";